exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gray_background {\n  background-color: #7a7a89;\n  margin-bottom: -17px; }\n\n.gray_background_soft {\n  background-color: #fafafa; }\n\n.texto {\n  color: white;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 1rem;\n  font-weight: 700;\n  text-align: center;\n  line-height: 1.7;\n  text-transform: uppercase;\n  padding-top: 17px;\n  padding-bottom: 17px;\n  margin: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxScatter/dboxScatter.component.scss
// module id = ../../../../../src/app/dboxScatter/dboxScatter.component.scss
// module chunks = main